<template>
  <div id="contract-editor-preview">
    <print ref="printRef">
      <page class="receipts">
        <template v-for="index in 2">
          <div :key="index">
            <div class="nation">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
            <div class="motto">Độc lập - Tự do - Hạnh phúc</div>
            <br/>
            <div class="hr"/>
            <div class="header">
              <div class="logo-holder">
                <logo-inversed-circle class="icon"/>
                <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
              </div>
              <div class="title-info">
                <span class="bill">PHIẾU THU TIỀN</span>
                <br/><br/>
                <strong class="info">Mã hợp đồng (HĐ): {{ branch.name }}-{{ contract.finfluxId }}</strong><br/>
                <strong class="info">Mã khách hàng (KH): HCMKH-{{ client.finfluxId }}</strong><br/>
                <strong class="info">Kho bãi: {{ storage.name }}</strong><br/>
              </div>
            </div>
            <table class="bill">
              <tr>
                <td>Ngày lập phiếu:</td>
                <td><span class="margin-left">{{ moment().format('DD-MM-YYYY, HH:mm') }}</span></td>
              </tr>
              <tr>
                <td><strong>Ngày tất toán:</strong></td>
                <td><strong class="margin-left">{{ moment(repaymentDate, DATE_FORMAT).format('DD-MM-YYYY') }}</strong></td>
              </tr>
              <tr>
                <td><strong>Họ và tên (KH):</strong></td>
                <td><strong class="margin-left">{{ `${client.lastName} ${client.firstName}` }}</strong></td>
              </tr>
              <tr>
                <td>Số điện thoại:</td>
                <td><span class="margin-left">{{ client.primaryPhoneNumber }}</span></td>
              </tr>
              <tr>
                <td>Địa chỉ:</td>
                <td><span class="margin-left">{{ getClientFullAddress(client) }}</span></td>
              </tr>
              <tr>
                <td><strong>Lý do:</strong></td>
                <td v-if="!liquidization"><strong class="margin-left">Tất toán HĐ số {{ contract.finfluxId }}</strong></td>
                <td v-if="liquidization"><strong class="margin-left">Thanh lý HĐ số {{ contract.finfluxId }}</strong></td>
              </tr>
              <tr>
                <td><strong>Hình thức thanh toán:</strong></td>
                <td><strong class="margin-left">{{ $t(filteredTransactions[0] ? filteredTransactions[0].type : '') }}</strong></td>
              </tr>
              <!-- TODO: implement discount -->
              <tr>
                <td><strong>Số tiền tất toán:</strong></td>
                <td><strong class="margin-left">{{ addCommas(totalAmount) }} VNĐ</strong></td>
              </tr>
              <tr v-if="previouslyRepaidAmount > 0">
                <td><strong>Đã thanh toán trước:</strong></td>
                <td><strong class="margin-left">({{ addCommas(previouslyRepaidAmount) }}) VNĐ</strong></td>
              </tr>
              <tr>
                <td><strong>Tổng tiền:</strong></td>
                <td><strong class="margin-left">{{ addCommas(totalAmount - previouslyRepaidAmount) }} VNĐ</strong></td>
              </tr>
              <tr v-if="contract.storageFeeLate > 0">
                <td><strong>Phí kho bãi trễ:</strong></td>
                <td><strong class="margin-left">{{ addCommas(Math.round(storageFeeLate / 1000) * 1000) }} VNĐ</strong></td>
              </tr>
            </table>
            <b-row class="sign">
              <b-col cols="6">
                <center>
                  <strong>Người nộp tiền</strong><br>
                  <strong>(Ký và ghi rõ họ tên)</strong>
                </center>
              </b-col>
              <b-col cols="6">
                <center>
                  <strong>Người lập phiếu</strong><br>
                  <strong>(Ký và ghi rõ họ tên)</strong>
                </center>
              </b-col>
            </b-row>
          </div>
          <div :key="`${index}-divider`" v-if="index==1" class="divider"/>
        </template>
      </page>
      <template v-for="previousTransaction in previousTransactions">
        <page :key="previousTransaction.id" class="receipts" v-if="previousTransactions.length">
          <div v-for="index in 2" :key="index">
            <div>
              <div class="nation">CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM</div>
              <div class="motto">Độc lập - Tự do - Hạnh phúc</div>
              <br/>
              <div class="hr"/>
              <div class="header">
                <div class="logo-holder">
                  <logo-inversed-circle class="icon"/>
                  <div class="camdo">camdo<strong class="nhanh">nhanh</strong></div>
                </div>
                <div class="title-info">
                  <span class="bill">{{ 'PHIẾU THU' }}</span>
                  <br/>
                  <strong class="info">Mã hợp đồng (HĐ): {{ branch.name }}-{{ contract.finfluxId || '••••••' }}</strong><br/>
                  <strong class="info">Mã khách hàng (KH): HCMKH-{{ client.finfluxId || '••••••' }}</strong><br/>
                  <strong class="info">Kho bãi: {{ storage.name }}</strong><br/>
                </div>
              </div>
              <table class="bill">
                <tr>
                  <td>Ngày lập phiếu:</td>
                  <td><span class="margin-left">{{ previousTransaction.registeredOn }}</span></td>
                </tr>
                <tr>
                  <td><strong>Ngày tất toán:</strong></td>
                  <td><strong class="margin-left">{{ moment(repaymentDate, DATE_FORMAT).format('DD-MM-YYYY') }}</strong></td>
                </tr>
                <tr>
                  <td><strong>Họ và tên (KH):</strong></td>
                  <td><strong class="margin-left">{{ `${client.lastName} ${client.firstName}` }}</strong></td>
                </tr>
                <tr>
                  <td>Số điện thoại:</td>
                  <td><span class="margin-left">{{ client.primaryPhoneNumber }}</span></td>
                </tr>
                <tr>
                  <td>Địa chỉ:</td>
                  <td><span class="margin-left">{{ getClientFullAddress(client) }}</span></td>
                </tr>
                <tr>
                  <td><strong>Lý do:</strong></td>
                  <td><strong class="margin-left">Thanh toán một phần HĐ số {{ contract.finfluxId }}</strong></td>
                </tr>
                <tr>
                  <td><strong>Hình thức thanh toán:</strong></td>
                  <td><strong class="margin-left">{{ $t(previousTransaction.type) }}</strong></td>
                </tr>
                <tr>
                  <td><strong>Số tiền thu được:</strong></td>
                  <td><strong class="margin-left">{{ addCommas(Math.round(parseFloat(parseFloat(previousTransaction.amount).toFixed(3)) * 1000) * 1000) }} VNĐ</strong></td>
                </tr>
              </table>
              <b-row class="sign">
                <b-col cols="6">
                  <center>
                    <strong>Người nộp tiền</strong><br>
                    <strong>(Ký và ghi rõ họ tên)</strong>
                  </center>
                </b-col>
                <b-col cols="6">
                  <center>
                    <strong>Người lập phiếu</strong><br>
                    <strong>(Ký và ghi rõ họ tên)</strong>
                  </center>
                </b-col>
              </b-row>
            </div>
            <div :key="`${index}-divider`" class="divider"/>
          </div>
        </page>
      </template>
    </print>
  </div>
</template>

<script>
import { ref, computed } from '@vue/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import moment from 'moment';

import { DISPLAY_DATE_FORMAT, DATE_FORMAT, INTEREST_TYPE } from '@/consts';
import { addCommas, camelToUpperSnake } from '@/helpers';

import Print from '@/components/Print';
import Page from '@/components/Page';
import LogoInversedCircle from '@/components/LogoInversedCircle';

const { useState: useAppState } = createNamespacedHelpers('app');

export default {
  name: 'ContractEditorPreview',
  components: {
    Print,
    Page,
    LogoInversedCircle
  },
  props: {
    client: {
      type: Object,
      default: () => {}
    },
    asset: {
      type: Object,
      default: () => {}
    },
    contract: {
      type: Object,
      default: () => {}
    },
    repaymentDate: {
      type: String,
      default: moment().format(DATE_FORMAT)
    },
    storageFeeLate: {
      type: Number,
      default: 0
    },
    overdueFee: {
      type: Number,
      default: 0
    },
    liquidizationFee: {
      type: Number,
      default: 0
    },
    failedCommitmentFee: {
      type: Number,
      default: 0
    },
    liquidization: {
      type: Boolean,
      default: false
    },
    allTransactions: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const { branches, storages, products, locations } = useAppState(['branches', 'storages', 'products', 'locations']);

    const asset = computed(() => props.asset);
    const contract = computed(() => props.contract);
    const client = computed(() => props.client);

    const branch = computed(() => branches.value.find((b) => b.id === client.value.branchId) || {});
    const storage = computed(() => storages.value.find((s) => s.id === asset.value.storageId) || {});
    const product = computed(() => products.value.find((p) => p.id === contract.value.productId) || {});

    const filteredTransactions = computed(() => (props.allTransactions.filter((item) => item.actions !== 'WAIVE' && item.status !== 'RETRACTED' && !item.isRenewalDifference)));

    const previousTransactions = computed(() => (filteredTransactions.value.slice(1)));
    const previouslyRepaidAmount = computed(() => previousTransactions.value.reduce((p, t) => p + Math.round(parseFloat(parseFloat(t.amount).toFixed(3)) * 1000) * 1000, 0));

    const printRef = ref(null);

    const overdueFee = computed(() => props.overdueFee);
    const liquidizationFee = computed(() => props.liquidizationFee);
    const failedCommitmentFee = computed(() => props.failedCommitmentFee);

    const totalAmount = computed(() => (
      contract.value.principalAmount
      + contract.value.interestAmount
      + contract.value.roundingFee
      + ((product.type === INTEREST_TYPE.ARREARS) ? (contract.value.interestAmount + contract.value.roundingFee) : 0)
      + overdueFee.value
      + liquidizationFee.value
      + failedCommitmentFee.value
      - contract.value.renewalDifference
    ));

    const getClientFullAddress = (c) => {
      let { address, locationId } = c;

      while (locationId) {
        const locId = locationId;
        const loc = locations.value.find((l) => l.id === locId);
        if (loc) {
          address += `, ${loc.name}`;
          locationId = loc.parent;
        } else {
          locationId = null;
        }
      }

      return address;
    };

    const print = () => {
      printRef.value.print();
    };

    return {
      moment,
      branch,
      storage,
      DISPLAY_DATE_FORMAT,
      DATE_FORMAT,
      addCommas,
      camelToUpperSnake,
      printRef,
      print,
      totalAmount,
      getClientFullAddress,
      filteredTransactions,
      previouslyRepaidAmount,
      previousTransactions
    };
  }
};
</script>

<style lang="scss">
@import "~@/assets/scss/colors";

#contract-editor-preview {
  padding: 20px;

  .terms {
    font-size: 12.5px;
    padding: 7mm 10mm 7mm 10mm;
  }

  .vehicle-authorization-letter {
    font-size: 14px;
    padding: 5mm 10mm 5mm 10mm;
  }

  .uppercase {
    text-transform: uppercase;
  }

  .hr {
    border: 1px solid $iron;
    width: 320px;
    margin: 0px auto;
  }

  .nation {
    size: 13px;
    text-align: center;
  }

  .motto {
    size: 11px;
    line-height: 18px;
    text-align: center;
  }

  .header {
    margin-top: 30px;
    position: relative;

    .logo-holder {
      position: absolute;
      top: 5px;
      left: 0;

      .left {
        padding-left: 26px;
        padding-top: 7px;
      }

      .icon {
        color: $alizarinCrimson;
        height: 80px;
        width: 80px;
      }

      .camdo {
        font-size: 15px;
        color: $carmine;
        font-family: 'Source Sans Pro', Tahoma, Arial;
      }

      .nhanh {
        font-size: 15px;
        color: $alizarinCrimson;
      }
    }

    .title-info {
      text-align: center;
      width: 100%;
    }

    .bill {
      text-transform: uppercase;
      font-weight: bolder;
      font-size: 24px;
    }

    .info {
      font-size: 13px;
    }
  }

  ul {
    list-style-type: circle;
  }

  table {
    width: 100%;
    border-spacing: 0;

    &.bill {
      margin-top: 50px;

      tr {
        td {
          &:first-child {
            width: 120px;
          }
        }
      }
    }

    &.authorized {
      margin-top: 35px;
      tr {
        td {
          &:first-child {
            width: 115px;
          }
        }
      }
    }

    &.contract {
      tr {
        td {
          &:first-child {
            width: 120px;
          }
        }
      }
    }

    &.bank {
      border: 1px solid $black;
      border-collapse: collapse;
      width: 478px;

      tr {
        td {
          border: 1px solid $black;
          border-collapse: collapse;
          padding: 3px;
        }
      }
    }

    .margin-left {
      margin-left: 50px;
    }

    td {
      &.label {
        width: 120px;
        vertical-align: top;
      }
    }
  }

  .sign {
    margin-top: 20px;
  }

  .divider {
    height: 0;
    border-bottom: 1px dashed $alto;
    width: calc(100% + 20mm);
    margin-left: -10mm;
    margin-top: 80px;
    margin-bottom: 20px;
  }
}
</style>
